import RibbonButton, { RibbonButtonState } from './RibbonButton';
import strings from 'owa-strings/owa-mail-strings';

const redo: RibbonButton = {
    key: 'redo',
    title: () => strings.redo,
    imageSrc: require('../svg/redo.svg'),
    shortcutWin: 'Ctrl+Y',
    shortcutMac: '⌘+Shift+Z',
    buttonState: formatState =>
        formatState.canRedo ? RibbonButtonState.Normal : RibbonButtonState.Disabled,
    onExecute: plugin => plugin.getEditor().redo(),
};

export default redo;
